import React from "react";
import { useSettings } from "hooks/useStore";
import clsx from "clsx/lite";

const formatTimeValue = (time) => +time <= 9 ? "0".concat(`${time}`) : time.toString();

const getAbbreviation = (key, value) => {
	if (key === "days") return value === 1 ? "day" : "days";
	if (key === "hours") return "HRS";
	return key.slice(0, 3);
};

const CountdownTimer = ({ timer, compactView = false, useSmallElements = false }) => {
	const { isClient } = useSettings(["isClient"]);
	if (!timer || !isClient) return null;

	return (
		<div className={
			clsx("flex justify-center items-center text-xs md:text-base rounded-md font-black", !compactView && "gap-x-3 px-2")}>
			{Object.entries(timer).map(([key, value], _index, array) => {
				const formattedValue = formatTimeValue(value);
				const isLastElement = _index === array.length - 1;
				return (
					<div className="flex flex-col items-center md:gap-0.5" key={key}>
						<div className="flex gap-1">
							{!compactView ?
								formattedValue.split("").map((char, index) => (
									<span key={index}
										className="bg-black text-white px-2 md:px-2.5 py-px md:py-1 text-sm md:text-base font-bold">
										{char}
									</span>
								)) :
								<div className="flex">
									<div className={clsx("flex flex-col bg-white text-black p-2 rounded-md items-center",
										useSmallElements ? "w-10 sm:py-0.5 min-w-0 lg:min-w-12 lg:py-2" : "min-w-12"
									)}>
										<span>
											{value}
										</span>
										<span className={clsx("text-xs opacity-60 font-semibold uppercase",
											useSmallElements && "text-[0.6rem] lg:text-xs")}>
											{getAbbreviation(key, value)}
										</span>
									</div>
									{!isLastElement && <span className="m-auto px-2">:</span>}
								</div>
							}
						</div>
						{!compactView && <span className="text-xxs md:text-xs uppercase">{key}</span>}
					</div>
				);
			})}
		</div>
	);
};

export default CountdownTimer;